import { lazy } from 'react'

export const BreathAfterClimbingV1 = lazy(
  () => import('./v1/BreathAfterClimbingV1'),
)
